"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
const react_1 = __importDefault(require("react"));
const RankArmyStarFilledLegacyIcon = (props) => (react_1.default.createElement(SvgIcon_1.default, { viewBox: "0 0 24 24", ...props },
    react_1.default.createElement("g", { id: "Filled_Icons_1_" },
        react_1.default.createElement("g", { id: "Filled_Icons" },
            react_1.default.createElement("polygon", { points: "20.021,9.535 14.121,8.683 11.486,3.376 8.852,8.683 2.952,9.535 7.221,13.671 6.215,19.508 11.486,16.752 \n\t\t\t16.758,19.507 15.752,13.671 \t\t" })),
        react_1.default.createElement("g", { id: "New_icons" })),
    react_1.default.createElement("g", { id: "Invisible_Shape" },
        react_1.default.createElement("rect", { fill: "none", width: "24", height: "24" }))));
exports.default = RankArmyStarFilledLegacyIcon;
